"use client";

import { c as _c } from "react/compiler-runtime";
import { Carousel, CarouselContent, CarouselItem } from "@repo/design-system/components/ui/carousel";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { combineEmploymentTypes } from "@repo/design-system/utils/helpers";
import Autoplay from "embla-carousel-autoplay";
import ClockIcon from "~/components/icons/clock-icon-eon";
import FileIcon from "~/components/icons/file-icon-eon";
import Home from "~/components/icons/home-eon";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
export const slideImagesEcon = ["images/header/subclients/econ/Slider 1.webp", "images/header/subclients/econ/Slider 2.webp", "images/header/subclients/econ/Slider 3.webp", "images/header/subclients/econ/Slider 4.webp", "images/header/subclients/econ/Slider 5.webp", "images/header/subclients/econ/Slider 6.webp"];
interface HeaderImageEconProps {
  job: Job;
}
export default function HeaderImageEcon(t0) {
  const $ = _c(33);
  const {
    job
  } = t0;
  const t = useLanguage();
  const showRemote = job.data.remote !== "Keine Angabe" && job.data.remote !== "Not specified";
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      loop: true,
      watchDrag: false
    };
    t2 = [Autoplay({
      delay: 4000,
      stopOnInteraction: false
    })];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="relative overflow-hidden xl:min-h-[520px]"><Carousel className="h-full w-full" opts={t1} plugins={t2}><CarouselContent className="ml-0 h-full">{slideImagesEcon.map(_temp)}</CarouselContent></Carousel></div>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== job.data.title) {
    t4 = <div className="text-lg xl:text-xl"><h1 className="mb-6 font-medium text-4xl lg:mb-12" data-source="job">{job.data.title}</h1></div>;
    $[3] = job.data.title;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <Home className="mt-1 size-8 shrink-0" />;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== job.data.company) {
    t6 = <p className="flex w-full items-start gap-3">{t5}<span data-source="job">{job.data.company}</span></p>;
    $[6] = job.data.company;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <FileIcon className="mt-1 size-8 shrink-0" />;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = showRemote && `${job.data.remote}, `;
  let t9;
  if ($[9] !== job.data.contract || $[10] !== t8) {
    t9 = <p className="flex w-full items-start gap-3">{t7}<span data-source="job">{t8}{job.data.contract}</span></p>;
    $[9] = job.data.contract;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <ClockIcon className="mt-1 size-8 shrink-0" />;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== job.data.employmentType || $[14] !== t) {
    t11 = combineEmploymentTypes(job.data.employmentType, t);
    $[13] = job.data.employmentType;
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t11) {
    t12 = <p className="flex w-full items-start gap-3">{t10}<span data-source="job">{t11}</span></p>;
    $[16] = t11;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t6 || $[20] !== t9) {
    t13 = <div className="space-y-2 font-bold text-2xl">{t6}{t9}{t12}</div>;
    $[18] = t12;
    $[19] = t6;
    $[20] = t9;
    $[21] = t13;
  } else {
    t13 = $[21];
  }
  let t14;
  if ($[22] !== job) {
    t14 = job.data.applicationUrl && job.data.applicationUrl.length > 2 && <ApplyButton job={job} variant="econ" />;
    $[22] = job;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  let t15;
  if ($[24] !== job) {
    t15 = job.data.applicationUrlDirect && <ApplyButton direct={true} job={job} variant="econ" />;
    $[24] = job;
    $[25] = t15;
  } else {
    t15 = $[25];
  }
  let t16;
  if ($[26] !== t14 || $[27] !== t15) {
    t16 = <div className="flex flex-col gap-3 pt-4 md:flex-row">{t14}{t15}</div>;
    $[26] = t14;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t13 || $[30] !== t16 || $[31] !== t4) {
    t17 = <section className="w-full bg-primary text-white lg:flex lg:justify-center print:hidden"><div className="grid w-full auto-rows-[1fr_2fr] xs:auto-rows-fr md:auto-rows-[3fr_2fr] lg:auto-cols-[2fr_1fr] lg:grid-flow-col">{t3}<div className="px-6 py-10 lg:max-w-[680px] lg:justify-self-start lg:px-10"><div className="mb-4 flex h-full flex-col justify-between">{t4}{t13}{t16}</div></div></div></section>;
    $[29] = t13;
    $[30] = t16;
    $[31] = t4;
    $[32] = t17;
  } else {
    t17 = $[32];
  }
  return t17;
}
function _temp(img, index) {
  return <CarouselItem className="h-full pl-0" key={img}><div className="relative h-full min-h-[300px] w-full md:min-h-[400px] xl:min-h-[520px]"><CustomImage className="object-cover" fetchPriority={index === 0 ? "high" : "auto"} fill={true} sizes="(min-width: 1024px) 67vw, 100vw" src={img} /></div></CarouselItem>;
}